import { OrNull } from '../interfaces';

export interface WorkflowItemClaimProceedModel {
  proceed: boolean;
  solutionDescription: OrNull<string>;
}
